<template>
  <v-popper
    class="ct-popover"
    :trigger="trigger"
    :options="{
      ...options,
      modifiers: { offset: { offset: '0,10px' } }
    }">
    <div class="popper ct-popper">
      <slot name="popper"></slot>
    </div>
    <slot slot="reference" name="reference"></slot>
  </v-popper>
</template>
<script>
import VuePopper from 'vue-popperjs'
import 'vue-popperjs/dist/vue-popper.css'

export default {
  name: 'CtPopover',
  components: {
    'v-popper': VuePopper
  },
  props: {
    trigger: {
      type: String,
      default: 'click'
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    placement: {
      type: String,
      default: 'top'
    },
    modifiers: {
      type: Object
    }
  },
  computed: {
    options () {
      return {
        title: this.title,
        placement: this.placement,
        modifiers: this.modifiers
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/_varaible.scss';
.ct-popover {
  min-width: 160px;
  .popper{
    box-shadow: 0px 2px 23px 0px rgba(35, 62, 114, 0.1);
    border-color: transparent;
    height: auto;
    background: #fff;
    line-height: 1.7;
    padding: 10px;
    color: $secondary;
    img {
      vertical-align: middle;
    }
    &__arrow[x-arrow]{
      border-color: #fff;
    }
  }
  .ct-popper[x-placement^="top"] {
    .popper__arrow{
      border-color: $secondary transparent transparent transparent;
    }
  }
  .popper[x-placement^="bottom"] {
    &__arrow{
      border-color:  transparent transparent $secondary transparent;
    }
  }
  .popper[x-placement^="left"] {
    &__arrow{
      border-color:  transparent transparent transparent $secondary;
    }
  }
  .popper[x-placement^="right"] {
    &__arrow{
      border-color:  transparent $secondary transparent transparent;
    }
  }
}
</style>
